"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePricingDefaults = void 0;
const helpers_1 = require("./helpers");
const validatePricingDefaults = (defaults, isBasePriceExperiment) => {
    return {
        min_price: !!((!isBasePriceExperiment && defaults.min_price > (0, helpers_1.toFloyd)(15)) ||
            (isBasePriceExperiment && (defaults.base_price && defaults.min_price <= defaults.base_price))),
        base_price: !!((!isBasePriceExperiment && defaults.base_price === undefined) ||
            (isBasePriceExperiment && defaults.base_price && defaults.base_price > (0, helpers_1.toFloyd)(15) && (defaults.base_price >= defaults.min_price))),
        checkin_days: defaults.checkin_days.length > 0
    };
};
exports.validatePricingDefaults = validatePricingDefaults;
//# sourceMappingURL=validation.js.map